/*$('.productView-nav').slick({
  //centerMode: true,
  //centerPadding: '8px',
  //slidesToShow: 1,
});*/

function openVideoModal(youtubeLink) {
  var modal = document.getElementById('videoModal');
  var iframe = document.getElementById('videoIframe');
  
  // Check if the URL is a YouTube watch URL and convert it to an embed URL
  var videoId = youtubeLink.split('v=')[1]; // Extract the video ID from the URL
  var embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1"; // Embed URL with autoplay
  
  // Set the YouTube iframe source
  iframe.src = embedUrl;
  
  // Show the modal
  modal.style.display = "flex"; // Use flexbox to center the modal
}

function closeVideoModal() {
  var modal = document.getElementById('videoModal');
  var iframe = document.getElementById('videoIframe');
  
  // Stop the video when the modal is closed
  iframe.src = ""; // Remove the iframe src to stop the video
  
  // Hide the modal
  modal.style.display = "none";
}
